(function () {
  "use strict";

  if (window.CCMBehaviorAnalytics && window.CCMBehaviorAnalytics.initialized) return;

  var timeThresholds = [15, 30, 60, 120];
  var scrollThresholds = [25, 50, 75, 90];
  var sentTimeThresholds = new Set();
  var sentScrollThresholds = new Set();
  var viewedSections = new Set();
  var sectionTimers = new WeakMap();
  var activeSeconds = 0;
  var maxScrollPercent = 0;
  var exitSent = false;
  var ticking = false;
  var currentPath = window.location.pathname + window.location.search;
  var previousPath = "";
  var entryPath = "";

  try {
    previousPath = window.sessionStorage.getItem("ccm_previous_path") || "";
    entryPath = window.sessionStorage.getItem("ccm_entry_path") || currentPath;
    window.sessionStorage.setItem("ccm_entry_path", entryPath);
    window.sessionStorage.setItem("ccm_previous_path", currentPath);
  } catch (error) {
    previousPath = document.referrer ? new URL(document.referrer).pathname : "";
    entryPath = currentPath;
  }

  function cleanText(value, limit) {
    return String(value || "").replace(/\s+/g, " ").trim().slice(0, limit || 100);
  }

  function track(eventName, parameters) {
    if (typeof window.CCMTrackEvent !== "function") return;
    window.CCMTrackEvent(eventName, Object.assign({
      page_path: currentPath,
      previous_path: previousPath,
      entry_path: entryPath,
      interaction_context: document.body.dataset.analyticsContext || document.body.className.match(/template-([\w-]+)/)?.[1] || "website"
    }, parameters || {}));
  }

  function sectionName(element) {
    var section = element && element.closest ? element.closest("[data-analytics-section], section, article, [id^='shopify-section-'], [data-ccm-build]") : null;
    if (!section) return "global";
    var explicit = section.getAttribute("data-analytics-section");
    if (explicit) return cleanText(explicit, 80);
    var heading = section.querySelector("h1, h2, h3");
    if (heading) return cleanText(heading.textContent, 80);
    return cleanText(section.id || section.getAttribute("data-ccm-build") || "content", 80);
  }

  function componentType(element) {
    if (!element) return "unknown";
    if (element.closest(".ccm-card, .featureCard, .product-card, [data-product-card]")) return "vehicle_card";
    if (element.closest("header, nav, [role='navigation']")) return "navigation";
    if (element.closest("footer")) return "footer";
    if (element.closest("form")) return "form";
    if (element.tagName === "BUTTON") return "button";
    return "link";
  }

  function destination(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return url.hostname;
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return cleanText(link.getAttribute("href"), 120);
    }
  }

  function vehicleDetails(element, link) {
    var card = element.closest(".ccm-card, .featureCard, .product-card, [data-product-card]");
    var path = link ? destination(link) : "";
    var handleMatch = path.match(/\/products\/([^?#/]+)/);
    var heading = card ? card.querySelector("h2, h3, h4, [data-product-title]") : null;
    return {
      vehicle_name: cleanText(heading ? heading.textContent : "", 100),
      product_handle: handleMatch ? handleMatch[1] : "",
      click_target: element.closest(".image-wrap, .thumb, picture, img") ? "image" : "text_or_button"
    };
  }

  document.addEventListener("click", function (event) {
    var target = event.target.closest("a[href], button, [role='button']");
    if (!target) return;

    var link = target.closest("a[href]");
    var text = cleanText(target.getAttribute("aria-label") || target.textContent, 100);
    var section = sectionName(target);
    var component = componentType(target);

    if (link) {
      var href = link.getAttribute("href") || "";
      if (/^tel:/i.test(href)) track("ccm_inquiry_intent", { inquiry_channel: "phone", cta_text: text, section_name: section });
      if (/^mailto:/i.test(href)) track("ccm_inquiry_intent", { inquiry_channel: "email", cta_text: text, section_name: section });
      if (/wa\.me|whatsapp/i.test(href)) track("ccm_inquiry_intent", { inquiry_channel: "whatsapp", cta_text: text, section_name: section });

      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && url.pathname !== window.location.pathname) {
          track("ccm_internal_link_click", {
            destination_path: destination(link),
            cta_text: text,
            section_name: section,
            component_type: component
          });
        }
      } catch (error) {}

      if (link.closest(".ccm-card, .featureCard, .product-card, [data-product-card]") && /\/products\//.test(link.href)) {
        track("ccm_vehicle_card_click", Object.assign({
          destination_path: destination(link),
          section_name: section
        }, vehicleDetails(target, link)));
      }
    }

    if (target.matches("button, [role='button'], .btn, .ccm-btn, .primary, [data-cta]") || target.closest(".btn, .ccm-btn, .primary, [data-cta]")) {
      track("ccm_cta_click", {
        cta_text: text,
        destination_path: link ? destination(link) : "",
        section_name: section,
        component_type: component,
        element_id: cleanText(target.id, 80)
      });
    }
  }, true);

  function scrollPercent() {
    var documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    var available = Math.max(1, documentHeight - window.innerHeight);
    return Math.min(100, Math.round((window.scrollY / available) * 100));
  }

  function recordScroll() {
    ticking = false;
    var percent = scrollPercent();
    maxScrollPercent = Math.max(maxScrollPercent, percent);
    scrollThresholds.forEach(function (threshold) {
      if (percent < threshold || sentScrollThresholds.has(threshold)) return;
      sentScrollThresholds.add(threshold);
      track("ccm_scroll_depth", { scroll_percent: threshold });
    });
  }

  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(recordScroll);
  }, { passive: true });

  window.setInterval(function () {
    if (document.hidden) return;
    activeSeconds += 1;
    timeThresholds.forEach(function (threshold) {
      if (activeSeconds < threshold || sentTimeThresholds.has(threshold)) return;
      sentTimeThresholds.add(threshold);
      track("ccm_engagement_time", { engagement_seconds: threshold, max_scroll_percent: maxScrollPercent });
    });
  }, 1000);

  function observeSections() {
    if (!("IntersectionObserver" in window)) return;
    var candidates = Array.from(document.querySelectorAll("main [data-analytics-section], main section, main article, main [id^='shopify-section-']"));
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var name = sectionName(entry.target);
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15 && !viewedSections.has(name)) {
          var timer = window.setTimeout(function () {
            viewedSections.add(name);
            track("ccm_content_section_view", {
              section_name: name,
              section_index: candidates.indexOf(entry.target) + 1,
              visible_seconds: 1
            });
            observer.unobserve(entry.target);
          }, 1000);
          sectionTimers.set(entry.target, timer);
        } else if (!entry.isIntersecting && sectionTimers.has(entry.target)) {
          window.clearTimeout(sectionTimers.get(entry.target));
          sectionTimers.delete(entry.target);
        }
      });
    }, { threshold: [0.15, 0.35], rootMargin: "0px 0px -10% 0px" });
    candidates.forEach(function (section) { observer.observe(section); });
  }

  function sendExit() {
    if (exitSent || activeSeconds < 1) return;
    exitSent = true;
    track("ccm_page_exit", {
      engagement_seconds: activeSeconds,
      max_scroll_percent: maxScrollPercent
    });
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") sendExit();
  });
  window.addEventListener("pagehide", sendExit);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", observeSections, { once: true });
  else observeSections();

  window.CCMBehaviorAnalytics = {
    initialized: true,
    track: track,
    sectionName: sectionName
  };
}());
